export default __webpack_public_path__ + "static/media/e.c008d354.mp4";